import { environment } from 'environments/environment';
import { CustomerInfo, KeyValueLegend } from './../../+tickets/folder/modal-ventas/ventas.service';
import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";
import {RequestMethod, Response} from "@angular/http";
import {RequestConfig, RestResponse} from "../../shared/rest/rest.request";
import {CustomHttp} from "../../common/http/custom.http";
import {PageImpl} from "../../common/http/PageImpl";
import {Groups} from "../+groups/group.service";
import { UserGeofenceView } from '../../+geocercas/geocercas.service';
import { es_ES, NzI18nService } from 'ng-zorro-antd';


@Injectable()
export class UsersService {
    private CREATE_CODE = new RequestConfig("USR", "application/json", true, RequestMethod.Post, "/users");
    private GET_QUIOSCO = new RequestConfig("USR", "application/json", true, RequestMethod.Post, "/entidadesExternas");
    private CREATE = new RequestConfig("USR", "application/json", true, RequestMethod.Post, "/usuario-turnolaboral");
    private MODIFICAR_USUARIO = new RequestConfig("USR", "application/json", true, RequestMethod.Put, "/usuario-turnolaboral");
    private EDIT_CODE = new RequestConfig("USR", "application/json", true, RequestMethod.Put, "/users/{userId}");
    private DELETE_CODE = new RequestConfig("USR", "application/json", true, RequestMethod.Delete, "/users/{userId}");
    private GET_CODE = new RequestConfig("USR", "application/json", true, RequestMethod.Get, "/users/{userId}");
    private GET_PAGE = new RequestConfig("USR", "application/json", true, RequestMethod.Post, "/users/list");
    // private GET_BY_GROUP = new RequestConfig("USR", "application/json", true, RequestMethod.Post, "/users/findByGroups{body}");
    private GET_BY_GROUP = new RequestConfig("USR", "application/json", true, RequestMethod.Post, "/users/findByGroups");
    private GET_BY_GROUP_NULL = new RequestConfig("USR", "application/json", true, RequestMethod.Post, "/users/findByGroups");
    private GET_SEARCH = new RequestConfig("USR", "application/json", true, RequestMethod.Post, "/users/search");
    private GET_USERS_BY_PROFILE = new RequestConfig("USR", "application/json", true, RequestMethod.Post, "/users/assigned");
    private GET_TREE_CODE = new RequestConfig("PRF", "application/json", true, RequestMethod.Get, "/groups/tree");
    private GET_TREE_SELECT_CODE = new RequestConfig("PRF", "application/json", true, RequestMethod.Get, "/groups/all");
    private FIND_EMPLOYEE = new RequestConfig("USR", "application/json", true, RequestMethod.Post, "/consultaEmpleado");

    constructor(private http: CustomHttp,
        private i18n: NzI18nService) {
            this.i18n.setLocale(es_ES);
    }

    /**
     * Envia una petición a WS para guardar usuario
     */
    save(user: User): Observable<RestResponse> {
        return this.http.sendRequest(this.CREATE_CODE, user)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    ObtenerQuiosco(sucursal: any): Observable<any> {
        let datos={
            sucursal:sucursal
        };
        this.GET_QUIOSCO.uri = '/entidadesExternas?sucursal='+`${sucursal}`;
        return this.http.sendRequestToUrl(environment.API_MEGA_2,this.GET_QUIOSCO)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }


    /**
     * Envia una petición a WS para guardar usuario con turno laboral
     */
    guardar(user: UserView): Observable<RestResponse> {
        return this.http.sendRequest(this.CREATE, user)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }
    /**
     * Envia una petición a WS para guardar usuario con turno laboral
     */
    modificar_usuario(user: UserView): Observable<RestResponse> {
        return this.http.sendRequest(this.MODIFICAR_USUARIO, user)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }
    /**
     * Envia petición a WS para obtener detalles de un ususario
     */
    get(idUserApp: number, image?: boolean, individualInfo?:boolean): Observable<UserView> {
        if (individualInfo == false || individualInfo == undefined) {
            let userData: any = localStorage.getItem('userData');
            if (userData != undefined || userData != null) {
                let userDataParse = JSON.parse(userData)
                if (userDataParse.userAppView.idUserApp != undefined) {
                    let newData = new BehaviorSubject<any>(null);
                    newData.next(userDataParse)
                    return newData;
                }
            }
            else {
                return this.http.sendRequest(this.GET_CODE, { image: image }, idUserApp)
                    .map((res: any) => {
                        try {
                            localStorage.setItem('userData', res._body);
                            return res.json();
                        } catch (e) {
                            return e => this.http.handleError(e);
                        }
                    })
            };
        }
        else {
            return this.http.sendRequest(this.GET_CODE, { image: image }, idUserApp)
                .map((res: any) => {
                    try {
                        return res.json();
                    } catch (e) {
                        return e => this.http.handleError(e);
                    }
                })
        }
    }

    

    /**
     * Envía petición a WS para editar datos de usuario
     */
    update(user: User): Observable<RestResponse> {
        return this.http.sendRequest(this.EDIT_CODE, user, user.idUserApp)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición al servidor para eliminar datos de usuario
     */
    delete(idUserApp: number) {
        return this.http.sendRequest(this.DELETE_CODE, {}, idUserApp)
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición al servidor para desactivar usuario
     */
    deactivateUser(idUserApp: number) {
        return this.http.sendRequest(this.DELETE_CODE, {}, idUserApp)
            .catch(error => this.http.handleError(error));
    }

    getPage(options: any): Observable<PageImpl<User>> {
        return this.http.sendRequest(this.GET_PAGE, options)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    /**
     * buscar usuarios
     */
    search(name: any, group?: any): Observable<PageImpl<User>> {
        let options = {
            name: name,
            page: 0,
            size: 100
        };
        return this.http.sendRequest(this.GET_PAGE, options)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    findByGroups(body:any): Observable<PageImpl<User>> {
        return this.http.sendRequest(this.GET_BY_GROUP, body)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    findByProfileAssigned(byProfile: ByProfile): Observable<Array<User>> {
        return this.http.sendRequest(this.GET_USERS_BY_PROFILE, byProfile)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));

    }

    getSearchPageUsers(searchUsers: UserRequestView): Observable<PageImpl<User>> {
        return this.http.sendRequest(this.GET_SEARCH, searchUsers)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición a WS para obtener el arbol de permisos general
    */
    getTreeGroups(): Observable<Array<RestResponse>> {
        return this.http.sendRequest(this.GET_TREE_CODE)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }


    /**
     * Envia petición a WS para obtener detalles de los grupos
     */
     getAllGroups(idGroups?:number[]): Observable<Array<Groups>> {
         if (idGroups.length == 0) {
             idGroups = [];
         }
         let userGroupsAll: any = localStorage.getItem('userGroupsAll');
         if (userGroupsAll != undefined || userGroupsAll != null) {
             let userGroupsAllParse = JSON.parse(userGroupsAll)
             if (userGroupsAllParse != undefined) {
                 let newData = new BehaviorSubject<any>(null);
                 newData.next(userGroupsAllParse)
                 return newData;
             }
         }
         else {
             return this.http.sendRequest(this.GET_TREE_SELECT_CODE, { idGroup: idGroups })
                 .map((res: any) => {
                     try {
                         localStorage.setItem('userGroupsAll', res._body);
                         return res.json();
                     } catch (e) {
                         return e => this.http.handleError(e);
                     }
                 })
         };
    }

    /**
     * Envia petición a WS para obtener el arbol de permisos seleccionados general
    */
    getTreeSelectGroups(idUser): Observable<Array<RestResponse>> {
        return this.http.sendRequest(this.GET_TREE_CODE, { idUser: idUser })
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    findEmployee(body: any): Observable<PageImpl<User>> {
        return this.http.sendRequestApiMega(this.FIND_EMPLOYEE, body)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
}

export const UsersGestionByProfile = [
    {
        idGestor: 146, gestor: "Jefe De Implementacion",
        idGestionado: 106, gestionado: "Supervisor De Construccion", accesoTotal: true
    },
    {
        idGestor: 146, gestor: "Jefe De Implementacion",
        idGestionado: 130, gestionado: "AGENTE CONSTRUCCION", accesoTotal: false
    },
    {
        idGestor: 106, gestor: "Supervisor De Construccion",
        idGestionado: 130, gestionado: "AGENTE CONSTRUCCION", accesoTotal: false
    },
    {
        idGestor: 73, gestor: "JEFE MANTENIMIENTO",
        idGestionado: 78, gestionado: "SUPERVISOR DE MANTENIMIENTO", accesoTotal: true
    },
    {
        idGestor: 73, gestor: "JEFE MANTENIMIENTO",
        idGestionado: 30, gestionado: "AGENTE MTTO", accesoTotal: false
    },
    {
        idGestor: 78, gestor: "SUPERVISOR DE MANTENIMIENTO",
        idGestionado: 30, gestionado: "AGENTE MTTO", accesoTotal: false
    },
    {
        idGestor: 102, gestor: "Supervisor De Radio Operador MYC (N1)",
        idGestionado: 82, gestionado: "RADIO OPERADOR MYC", accesoTotal: true
    },
    {
        idGestor: 102, gestor: "Supervisor De Radio Operador MYC (N1)",
        idGestionado: 30, gestionado: "AGENTE MTTO", accesoTotal: false
    }
];

@Injectable()
export class User {
    public idUserApp: number;
    public profileId: number;
    public permissionsList: Array<number> = [];
    public name: string;
    public username: string;
    public email: string;
    public numTel?: string;
    public extra1: string;
    public extra2: string;
    public extra3: string;
    public extra4: boolean;
    public extra5: boolean;
    public groupList: Array<number> = [];
    public groups: Array<Groups> = [];
    public password: string;
    public extraList: Array<ExtraInfo> = [];
    public status: boolean;
    public idWorkShift: number;
    public imageProfile: ImageProfile;
    public connectionStatus: string;
    public idUsersAssigned: Array<number> = [];
    public infoUsers: Array<any> = [];
    public profileName: string;
    public userGeofenceViewList: Array<UserGeofenceView> = [];
    public viewInScheduleViewList: Array<InScheduleViewList> = [];
    public projectionViewInScheduleView: Array<ProjectionViewInSchedule> = [];
    public extraConfiguration: UserExtraConfiguration = new UserExtraConfiguration();
    public userGeofenceAlertViewList: Array<GeofenceAlertView> = [];
    public user_dimme: boolean = true;
}


export enum RecoveryLogType {
    CNR = 1,
    VISIT = 2,
    RECOVER = 3,
    VISITSALE = 4,
    SALE = 5
}



export class GeofenceAlertView {
    idUserApp: number;
    idGeofence: number;
    geofenceName: string;
}
export class UserExtraConfiguration {
    iam: number[];
    dum: Dum = new Dum();
    nvm: number;
    tmad: number;
    att: number;
    e2e?: boolean;
    bulk?:boolean;
    priorizar?:boolean;
    pagos?: boolean;
    quiosco?: any;
    idquiosco?:any;
    validarEquipo?: boolean;
    mdm?:boolean;
    metrospre?: number;
    device?:boolean;
    externa?:boolean;
    cuadlog?:boolean;
    autoasgeoale?:boolean;
    vtw?:boolean;
    agendex?:boolean;
    tmm?:number;
    ntm?:boolean;
    dashProd?: boolean;
    editarPerfil?:boolean;
}

export class Dum {
   ne: number;
}

export class ExtraInfo {
    public userExtraInfoId: number;
    public key: string;
    public value: string;
    public status: string = 'ACTIVO';
}

export class ImageProfile {
    contentType: string;
    createdDate: string;
    encodedImageContent: string;
    encodedImageContentSmall: string = null;
    imageName: string;
    userImageId: 0
}

export class ByProfile {
    idProfile: number;
    idGroups: Array<number> = [];
}

@Injectable()
export class UserRequestView {
    public name: string;
    public page: number;
    public size: number;
    public orderColumn: string;
    public orderType: string;
    public idGroups: Array<number> = [];
}
//gloria 18-06-2020
export class UserView{
    userAppView: User;
    idWorkShift: number;
}

export class InScheduleViewList{
    idToViewInSchedule: any;
    userNameToViewInSchedule: string;
}

export class  ProjectionViewInSchedule {
    idUserApp: number;
    name: string;
    userName: string;
    connectionStatus: string;
    profileName: string;
    idGroup: number;
    groupName: string;
    status: boolean;
    extra1: string;
}

export class UserAdvanceSearch {
    active: boolean;
    name: string;
    page: number;
    size: number;
    orderColumn: string;
    orderType: string;
    idTypeTicket: Array<number> = [];
    sucursal: string;
    typePackage: number;
}

export class FindByGroupsAdvanceSearch {
    page: number;
    size: number;
    active: boolean;
    orderColum: string;
    orderType: string;
    // idGroup: number;
    idGroup: Array<number> = [];
    userName: string;
    extra3?: string;
    iam: Array<number> = [];
    agente?: boolean;
}

export class FindByGroupsAdvanceSearch2 {
    page: number;
    size: number;
    active: boolean;
    orderColum: string;
    orderType: string;
    idGroup: number[];
    userName: string;
    extra3?: string;
    agente?: boolean;
}


export interface Principals {
    active: boolean,
    children: Zonas[],
    content: string,
    expanded: boolean,
    extra3: boolean,
    id: number,
    module: number | null
}

export interface Zonas {
    active: boolean,
    children: GroupsChildren[],
    content: string,
    expanded: boolean,
    extra3: boolean,
    id: number,
    module: number | null
}

export interface GroupsChildren {
    active: boolean,
    children: Childrens[],
    content: string,
    expanded: boolean,
    extra3: boolean,
    id: number,
    module: number | null,
    region?: string | null
}
export interface Childrens {
    active: boolean,
    children: null,
    content: string,
    expanded: boolean,
    extra3: boolean,
    id: number,
    module: number | null,
    region?: string | null,
    ventaInmediata?: boolean
}

export enum TypeTicket {
    MANTENIMIENTO = 1,
    REC_CLIENTES = 2,
    OPERACIONES = 3,
    METROCARRIER = 4,
    VENTAS = 5,
    REC_EQUIPOS = 6,
    SUP_CONSTRUCCION = 7,
    CONSTRUCCION = 8,
    PLANTA_INTERNA = 10,
}